import { QuestionKey } from '@hb/modules/global/global.constants';
import { GlobalControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { RenovationStoreService } from '@hb/modules/property/renovation-part/renovation-store.service';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { PropertyTypePipe } from '@hb/modules/property/renovation-part/transformer/property-type/property-type-pipe';
import { AdditionalInfoComponent } from '@hb/modules/global/additional-info';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';
import { ApButtonGroupComponent, ApButtonGroupItemComponent } from '@ap/button';

@Component({
    selector: 'renovation',
    templateUrl: './renovation.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        AsyncPipe,
        ApRadioModule,
        ApButtonGroupComponent,
        ApButtonGroupItemComponent,
        AdditionalInfoComponent,
        CoApplicantPipe,
        PropertyTypePipe
    ],
    providers: [
        { provide: GLOBAL_STORE, useExisting: RenovationStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.RENOVATION }
    ]
})
export class RenovationComponent extends GlobalInjectComponent<RenovationStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(RenovationStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new GlobalControl<string>(
            this.analyticsService,
            this.questionKey,
            this.store.getRenovation()?.toString()
        );
        this.mainApplicantControl.onUpdate().subscribe((value) => this.store.setRenovation(Boolean(JSON.parse(value))));
    }

    onButtonGroupClicked($event: string): void {
        this.mainApplicantControl.setValue($event);
    }
}
